import { createGlobalStyle } from "styled-components";
import { colors, fonts } from "./variables.js";

/*	@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait)
*/

const GlobalStyle = createGlobalStyle`
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	p {
		line-height: 1.5;
	}

	html {
		font-size: 22px;
		font-family: ${fonts.default};
		scroll-behavior: smooth;
		overflow-x: hidden;
		width: 100%;
		max-width: 100%;

		@media (max-width: 1550px) {
			font-size: 20px;
		}

		@media (max-width: 1366px) {
			font-size: 18px;
		}

		@media (max-width: 1150px) {
			font-size: 15px;
		}

		@media (max-width: 1000px) {
			font-size: 14px;
		}

		@media (max-width: 900px) {
			font-size: 16px;
		}

		@media only screen and (max-device-width: 800px) and (orientation: portrait) {
			font-size: 20px;
		}

		@media (max-width: 600px) {
			font-size: 14px;
		}

		@media (max-width: 400px) {
			font-size: 14px;
		}
	}

	body {
		margin-top: 3.6rem;
		max-width: 100%;
		background: ${colors.bg};
	}
`;

export default GlobalStyle;
